<div class="spinner">
  <fa-icon class="spin" [spin]="true" [icon]="faSpinner"></fa-icon>
</div>
